<template>
    <el-date-picker style="width: 350px; margin-right: 15px" v-model="date" type="daterange" value-format="YYYY-MM-DD" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="datePickerChange" />
    <el-radio-group v-model="day" @change="dayChange">
        <el-radio :label="7">近7天</el-radio>
        <el-radio :label="30">近30天</el-radio>
    </el-radio-group>
</template>

<script setup>
import { watchEffect, ref } from "vue";
import { getDateBefore } from "@/utils/date";

const props = defineProps({
    start: { type: String, default: "" },
    end: { type: String, default: "" },
});
const emit = defineEmits(["change", "update:start", "update:end"]);
const day = ref("");
const date = ref([]);

// 7/30天切换
function dayChange(e) {
    if (!e) return;
    date.value = [getDateBefore(e), getDateBefore(0)];
    sendEmit();
}

// 日期选择器切换
function datePickerChange() {
    day.value = "";
    sendEmit();
}

// 发送事件，修改外部值
function sendEmit() {
    emit("update:start", date.value?.[0] || "");
    emit("update:end", date.value?.[1] || "");
    emit("change", date.value);
}

// 监听外部改变或赋值
watchEffect(() => {
    if (props.start && props.end) {
        date.value = [props.start, props.end];
    } else {
        date.value = [];
        day.value = "";
    }
});
</script>
